(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["featured-product"] && !Shopify.designMode) return;
  try {
    
	class ProductModal extends ModalDialog {
		constructor() {
			super();
		}
		hide() {
			super.hide();
			window.pauseAllMedia();
		}
		show(opener) {
			super.show(opener);
			//this.showActiveMedia();
			this.constProductPageSwiperCall()
		}
		showActiveMedia() {
			this.querySelectorAll(`[data-media-id]:not([data-media-id="${this.openedBy.getAttribute("data-media-id")}"])`).forEach((element) => {
					element.classList.remove('active');
				}
			)
			const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute("data-media-id")}"]`);
			activeMedia.classList.add('active');
			activeMedia.scrollIntoView();
			if (activeMedia.nodeName == 'DEFERRED-MEDIA' && activeMedia.querySelector('template')?.content?.querySelector('.js-youtube'))
				activeMedia.loadContent();
		}			
		constProductPageSwiperCall(showActiveMedia) {
			const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute("data-media-id")}"]`);
			let activeMediaIndex = 0
			
			this.querySelectorAll(`.swiper-slide`).forEach((element, index) => {
					if(element == activeMedia){
						activeMediaIndex = index
					}
				}
			)
			const prodPageSwiper = new Swiper("#featured-product-swiper", {
				zoom: true,
				centeredSlides: false,
				slidesPerView: 1,
				autoheight: true,
				watchSlidesVisibility: false,
				watchSlidesProgress: true,
				observer: true,
				observeParents: true,
				init: false,
				navigation: {
					nextEl: ".swiper-button-next-prod-page",
					prevEl: ".swiper-button-prev-prod-page",
				}
			});
			prodPageSwiper.on('init', function() {
				prodPageSwiper.slideTo(activeMediaIndex, 0, false);
			});
			prodPageSwiper.init()
			document.querySelector('.product-media-modal__toggle').addEventListener("click", function(){ prodPageSwiper.destroy() });
		}
	}

	class ProductRecommendations extends HTMLElement {
		constructor() {
			super();
			const handleIntersection = (entries, observer) => {
				if (!entries[0].isIntersecting) return;
				observer.unobserve(this);

				fetch(this.dataset.url)
					.then(response => response.text())
					.then(text => {
						const html = document.createElement('div');
						html.innerHTML = text;
						const recommendations = html.querySelector('product-recommendations');
						if (recommendations && recommendations.innerHTML.trim().length) {
							this.innerHTML = recommendations.innerHTML;
						}
					})
					.catch(e => {
						console.error(e);
					});
			}
			new IntersectionObserver(handleIntersection.bind(this), {rootMargin: '0px 0px 200px 0px'}).observe(this);
		}
	}

	customElements.define('product-modal', ProductModal);
	customElements.define('product-recommendations', ProductRecommendations);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
  class LocalizationForm extends HTMLElement {
  	constructor() {
  		super();
  		this.elements = {
  			input: this.querySelector(
  				'input[name="locale_code"], input[name="country_code"]'
  			),
  			button: this.querySelector('button'),
  			panel: this.querySelector('ul'),
  		};
  		this.elements.button.addEventListener(
  			'click',
  			this.openSelector.bind(this)
  		);
  		this.elements.button.addEventListener(
  			'focusout',
  			this.closeSelector.bind(this)
  		);
  		this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

  		this.querySelectorAll('a').forEach((item) =>
  			item.addEventListener('click', this.onItemClick.bind(this))
  		);
  	}

  	hidePanel() {
  		this.elements.button.setAttribute('aria-expanded', 'false');
  		this.elements.panel.setAttribute('hidden', true);
  	}

  	onContainerKeyUp(event) {
  		if (event.code.toUpperCase() !== 'ESCAPE') return;

  		this.hidePanel();
  		this.elements.button.focus();
  	}

  	onItemClick(event) {
  		event.preventDefault();
  		this.elements.input.value = event.currentTarget.dataset.value;
  		this.querySelector('form')?.submit();
  	}

  	openSelector() {
  		this.elements.button.focus();
  		this.elements.panel.toggleAttribute('hidden');
  		this.elements.button.setAttribute(
  			'aria-expanded',
  			(
  				this.elements.button.getAttribute('aria-expanded') === 'false'
  			).toString()
  		);
  	}

  	closeSelector(event) {
  		const shouldClose =
  			event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
  		if (event.relatedTarget === null || shouldClose) {
  			this.hidePanel();
  		}
  	}
  }

  customElements.define('localization-form', LocalizationForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.headerId = document.getElementById('section-header').getAttribute('data-header-id');
      this.header = document.getElementById(`shopify-section-${this.headerId}`);
      this.headerBounds = {};
      this.currentScrollTop = 0;
      this.createObserver();
    }
    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {}

    hide() {}

    reveal() {
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.add('shopify-section-header-sticky', 'animate');
    }

    reset() {}

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('details-disclosure');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-cart"]) return;
  try {
    
	class CartNote extends HTMLElement {
		constructor() {
			super();

			this.addEventListener(
				'change',
				debounce((event) => {
					const body = JSON.stringify({ note: event.target.value });
					fetch(`${routes.cart_update_url}`, { ...fetchConfig(), ...{ body } });
				}, 300)
			);
		}
	}
	customElements.define('cart-note', CartNote);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
  function initProductZoomBar(swiper, modal) {
    if (!modal || !swiper) return null;

    const oldControls = modal.querySelector('.product-zoom-controls');
    if (oldControls) {
      oldControls.remove();
    }

    const minZoom = 1;
    const maxZoom = 6;
    const zoomStep = 0.5;
    const wheelZoomStep = 0.35;

    let scale = 1;
    let translateX = 0;
    let translateY = 0;
    let isDragging = false;
    let startX = 0;
    let startY = 0;

    const controls = document.createElement('div');
    controls.className = 'product-zoom-controls';

    const zoomPlusButton = document.createElement('button');
    zoomPlusButton.className = 'product-zoom-controls__button product-zoom-controls__button--plus';
    zoomPlusButton.type = 'button';
    zoomPlusButton.setAttribute('aria-label', 'Aumentar zoom');
    zoomPlusButton.textContent = '+';

    const zoomRangeWrapper = document.createElement('div');
    zoomRangeWrapper.className = 'product-zoom-controls__range-wrapper';

    const zoomRange = document.createElement('input');
    zoomRange.className = 'product-zoom-controls__range';
    zoomRange.type = 'range';
    zoomRange.min = String(minZoom);
    zoomRange.max = String(maxZoom);
    zoomRange.step = String(zoomStep);
    zoomRange.value = String(scale);

    const zoomMinusButton = document.createElement('button');
    zoomMinusButton.className = 'product-zoom-controls__button product-zoom-controls__button--minus';
    zoomMinusButton.type = 'button';
    zoomMinusButton.setAttribute('aria-label', 'Disminuir zoom');
    zoomMinusButton.textContent = '-';

    zoomRangeWrapper.appendChild(zoomRange);

    controls.appendChild(zoomPlusButton);
    controls.appendChild(zoomRangeWrapper);
    controls.appendChild(zoomMinusButton);

    modal.appendChild(controls);

    function onZoomRangeInput(event) {
      setZoom(Number(event.target.value));
    }

    function onZoomPlusClick(event) {
      event.preventDefault();
      event.stopPropagation();

      setZoom(scale + zoomStep);
    }

    function onZoomMinusClick(event) {
      event.preventDefault();
      event.stopPropagation();

      setZoom(scale - zoomStep);
    }

    zoomRange.addEventListener('input', onZoomRangeInput);
    zoomPlusButton.addEventListener('click', onZoomPlusClick);
    zoomMinusButton.addEventListener('click', onZoomMinusClick);

    swiper.on('slideChangeTransitionStart', hideZoomControlsDuringSlide);
    swiper.on('slideChange', onSlideChange);

    function hideZoomControlsDuringSlide() {
      controls.classList.add('is-repositioning');
    }

    function getActiveSlide() {
      return swiper.slides && swiper.slides[swiper.activeIndex]
        ? swiper.slides[swiper.activeIndex]
        : null;
    }

    function getActiveImage() {
      const activeSlide = getActiveSlide();
      if (!activeSlide) return null;

      return activeSlide.querySelector('.swiper-zoom-container img');
    }

    function resetZoom() {
      scale = minZoom;
      translateX = 0;
      translateY = 0;
      isDragging = false;

      zoomRange.value = String(minZoom);

      controls.classList.remove('is-fixed-to-screen');

      Array.from(swiper.slides || []).forEach((slide) => {
        slide.classList.remove('is-zoomed');

        const img = slide.querySelector('.swiper-zoom-container img');
        if (img) {
          img.style.transform = '';
        }
      });

      swiper.allowTouchMove = true;
    }

    function applyZoom() {
      const activeSlide = getActiveSlide();
      const img = getActiveImage();

      if (!activeSlide || !img) return;

      if (scale <= 1) {
        translateX = 0;
        translateY = 0;
        activeSlide.classList.remove('is-zoomed');
        swiper.allowTouchMove = true;
      } else {
        activeSlide.classList.add('is-zoomed');
        swiper.allowTouchMove = false;
      }

      img.style.transform = `translate3d(${translateX}px, ${translateY}px, 0) scale(${scale})`;
    }

    function setZoom(nextScale) {
      scale = Math.min(Math.max(nextScale, minZoom), maxZoom);

      zoomRange.value = String(scale);

      applyZoom();
    }


    function onWheel(event) {
      const activeSlide = getActiveSlide();

      if (!activeSlide) return;
      if (!activeSlide.contains(event.target)) return;
      if (!event.target.closest('.swiper-zoom-container')) return;
      if (event.target.closest('.product-zoom-controls')) return;

      event.preventDefault();
      event.stopPropagation();

      const direction = event.deltaY < 0 ? 1 : -1;
      const nextScale = scale + direction * wheelZoomStep;

      setZoom(nextScale);
    }

    function onControlsClick(event) {
      event.stopPropagation();
    }

    function onPointerDown(event) {
      const activeSlide = getActiveSlide();

      if (!activeSlide || scale <= 1) return;
      if (!activeSlide.contains(event.target)) return;
      if (!event.target.closest('.swiper-zoom-container')) return;
      if (event.target.closest('.product-zoom-controls')) return;

      isDragging = true;
      startX = event.clientX - translateX;
      startY = event.clientY - translateY;

      if (event.target.setPointerCapture) {
        event.target.setPointerCapture(event.pointerId);
      }

      event.preventDefault();
    }

    function onPointerMove(event) {
      if (!isDragging || scale <= 1) return;

      translateX = event.clientX - startX;
      translateY = event.clientY - startY;

      applyZoom();
    }

    function onPointerUp() {
      isDragging = false;
    }

    function onSlideChange() {
      hideZoomControlsDuringSlide();
      resetZoom();
    }

    controls.addEventListener('click', onControlsClick);

    modal.addEventListener('wheel', onWheel, { passive: false });
    modal.addEventListener('pointerdown', onPointerDown);
    modal.addEventListener('pointermove', onPointerMove);
    modal.addEventListener('pointerup', onPointerUp);
    modal.addEventListener('pointercancel', onPointerUp);

    resetZoom();

    return function destroyZoomBar() {
      zoomRange.removeEventListener('input', onZoomRangeInput);
      zoomPlusButton.removeEventListener('click', onZoomPlusClick);
      zoomMinusButton.removeEventListener('click', onZoomMinusClick);

      controls.removeEventListener('click', onControlsClick);

      modal.removeEventListener('wheel', onWheel);
      modal.removeEventListener('pointerdown', onPointerDown);
      modal.removeEventListener('pointermove', onPointerMove);
      modal.removeEventListener('pointerup', onPointerUp);
      modal.removeEventListener('pointercancel', onPointerUp);

      swiper.off('slideChange', onSlideChange);

      resetZoom();
      controls.remove();
    };
  }
  class ProductModal extends ModalDialog {
    constructor() {
      super();
    }
    hide() {
      this.classList.remove('is-mobile-opening');

      super.hide();
      window.pauseAllMedia();
    }
    show(opener) {
      if (!opener) return;

      super.show(opener);

      const isMobile = window.matchMedia('(max-width: 989px)').matches;

      if (isMobile) {
        this.classList.remove('is-mobile-opening');

        requestAnimationFrame(() => {
          setTimeout(() => {
            this.classList.add('is-mobile-opening');
          }, 300);

          setTimeout(() => {
            this.classList.remove('is-mobile-opening');
          }, 1200);
        });
      }

      requestAnimationFrame(() => {
        this.constProductPageSwiperCall(opener);
      });
    }
    showActiveMedia() {
      this.querySelectorAll(
        `[data-media-id]:not([data-media-id="${this.openedBy.getAttribute('data-media-id')}"])`
      ).forEach((element) => {
        element.classList.remove('active');
      });
      const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute('data-media-id')}"]`);
      activeMedia.classList.add('active');
      activeMedia.scrollIntoView();
      if (
        activeMedia.nodeName == 'DEFERRED-MEDIA' &&
        activeMedia.querySelector('template')?.content?.querySelector('.js-youtube')
      )
        activeMedia.loadContent();
    }

    constProductPageSwiperCall(opener = this.openedBy) {
      const openedMediaId = opener?.getAttribute('data-media-id');

      let activeMedia = openedMediaId
        ? this.querySelector(`[data-media-id="${openedMediaId}"]`)
        : null;

      if (!activeMedia && openedMediaId) {
        const rawMediaId = openedMediaId.split('-').pop();

        activeMedia = this.querySelector(
          `[data-media-id$="-${rawMediaId}"], [data-media-id="${rawMediaId}"]`
        );
      }

      if (!activeMedia) {
        activeMedia = this.querySelector('#product-page-swiper .s3 > .swiper-slide');
      }

      if (!activeMedia) return;

      const color = activeMedia.getAttribute('data-color');

      changeZoomSliderImages(color);

      const swiperEl = this.querySelector('#product-page-swiper');

      if (!swiperEl) return;

      if (swiperEl.swiper && !swiperEl.swiper.destroyed) {
        swiperEl.swiper.destroy(true, true);
      }

      const visibleSlides = Array.from(
        swiperEl.querySelectorAll('.s3 > .swiper-slide')
      );

      let activeMediaIndex = visibleSlides.findIndex((slide) => slide === activeMedia);

      if (activeMediaIndex < 0) {
        activeMediaIndex = 0;
      }

      const isDesktop = window.matchMedia('(min-width: 990px)').matches;

      let destroyZoomBar = null;

      const prodPageSwiper = new Swiper(swiperEl, {
        zoom: isDesktop ? false : true,

        effect: isDesktop ? 'slide' : 'creative',

        creativeEffect: isDesktop
          ? undefined
          : {
              limitProgress: 2,
              prev: {
                translate: [0, 0, -1],
                opacity: 1,
              },
              next: {
                translate: ['100%', 0, 0],
                opacity: 1,
              },
            },

        centeredSlides: false,
        slidesPerView: 1,
        slidesPerGroup: 1,
        spaceBetween: 0,
        autoHeight: false,

        watchSlidesVisibility: false,
        watchSlidesProgress: true,
        observer: false,
        observeParents: false,

        init: false,

        loop: false,
        rewind: false,

        navigation: false,

        pagination: {
          el: this.querySelector('.pdp-modal-pagination'),
          clickable: true,
        },

        on: {
          init: function () {
            requestAnimationFrame(() => {
              this.update();
              this.slideTo(activeMediaIndex, 0, false);
            });
          },

          zoomChange: function (swiper, scale) {
            swiper.allowTouchMove = scale <= 1;
          },

          slideChange: function () {
            if (this.zoom && this.zoom.out) {
              this.zoom.out();
            }

            this.allowTouchMove = true;
          },
        }
      });

      prodPageSwiper.on('init', () => {
        if (isDesktop) {
          if (prodPageSwiper.zoom && prodPageSwiper.zoom.disable) {
            prodPageSwiper.zoom.disable();
          }

          destroyZoomBar = initProductZoomBar(
            prodPageSwiper,
            this
          );
        }
      });

      prodPageSwiper.init();

      let touchStartX = null;
      let touchStartIndex = null;

      function getTouchClientX(event) {
        const originalEvent = event.originalEvent || event;
        const touch = originalEvent.changedTouches?.[0] || originalEvent.touches?.[0];

        if (touch) {
          return touch.clientX;
        }

        return originalEvent.clientX ?? null;
      }

      function onModalSwiperTouchStart(swiper, event) {
        if (isDesktop) return;

        touchStartX = getTouchClientX(event);
        touchStartIndex = swiper.activeIndex;
      }

      function onModalSwiperTouchEnd(swiper, event) {
        if (isDesktop) return;
        if (touchStartX === null || touchStartIndex === null) return;

        const touchEndX = getTouchClientX(event);

        if (touchEndX === null) return;

        const diffX = touchEndX - touchStartX;
        const swipeThreshold = 40;
        const lastIndex = swiper.slides.length - 1;

        if (Math.abs(diffX) < swipeThreshold) {
          touchStartX = null;
          touchStartIndex = null;
          return;
        }

        const swipedLeft = diffX < 0;
        const swipedRight = diffX > 0;

        if (touchStartIndex >= lastIndex && swipedLeft) {
          requestAnimationFrame(() => {
            swiper.slideTo(0);
          });
        }

        if (touchStartIndex <= 0 && swipedRight) {
          requestAnimationFrame(() => {
            swiper.slideTo(lastIndex);
          });
        }

        touchStartX = null;
        touchStartIndex = null;
      }

      prodPageSwiper.on('touchStart', onModalSwiperTouchStart);
      prodPageSwiper.on('touchEnd', onModalSwiperTouchEnd);


      const nextButton = this.querySelector('.swiper-button-next-prod-page');
      const prevButton = this.querySelector('.swiper-button-prev-prod-page');


      let queuedSteps = 0;
      let isManualSliding = false;

      function getLastIndex() {
        return prodPageSwiper.slides.length - 1;
      }

      function getNextIndex(currentIndex) {
        const lastIndex = getLastIndex();

        if (currentIndex >= lastIndex) {
          return 0;
        }

        return currentIndex + 1;
      }

      function getPrevIndex(currentIndex) {
        const lastIndex = getLastIndex();

        if (currentIndex <= 0) {
          return lastIndex;
        }

        return currentIndex - 1;
      }

      function processQueuedNavigation() {
        if (isManualSliding) return;
        if (queuedSteps === 0) return;
        if (!prodPageSwiper || prodPageSwiper.destroyed) return;

        isManualSliding = true;

        const direction = queuedSteps > 0 ? 1 : -1;

        queuedSteps = queuedSteps - direction;

        const currentIndex = prodPageSwiper.activeIndex;
        const nextIndex = direction > 0
          ? getNextIndex(currentIndex)
          : getPrevIndex(currentIndex);

        prodPageSwiper.slideTo(nextIndex);

        setTimeout(function () {
          isManualSliding = false;
          processQueuedNavigation();
        }, prodPageSwiper.params.speed + 30);
      }

      function queueNavigation(direction, event) {
        if (event) {
          event.preventDefault();
          event.stopPropagation();
          event.stopImmediatePropagation();
        }

        queuedSteps += direction;

        processQueuedNavigation();
      }

      function goNext(event) {
        queueNavigation(1, event);
      }

      function goPrev(event) {
        queueNavigation(-1, event);
      }

      if (nextButton) {
        nextButton.addEventListener('click', goNext);
      }

      if (prevButton) {
        prevButton.addEventListener('click', goPrev);
      }

      const closeButton = this.querySelector('.product-media-modal__toggle');

      if (!closeButton) return;

      closeButton.addEventListener(
        'click',
        function () {
          if (nextButton) {
            nextButton.removeEventListener('click', goNext);
          }

          if (prevButton) {
            prevButton.removeEventListener('click', goPrev);
          }

          queuedSteps = 0;
          isManualSliding = false;

          if (destroyZoomBar) {
            destroyZoomBar();
            destroyZoomBar = null;
          }

          if (prodPageSwiper && !prodPageSwiper.destroyed) {
            prodPageSwiper.off('touchStart', onModalSwiperTouchStart);
            prodPageSwiper.off('touchEnd', onModalSwiperTouchEnd);
            prodPageSwiper.destroy(true, true);
          }
        },
        { once: true }
      );
    }
  }

  class ProductRecommendations extends HTMLElement {
    constructor() {
      super();

      const handleIntersection = (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);

        fetch(this.dataset.url)
          .then((response) => response.text())
          .then((text) => {
            const html = document.createElement('div');
            html.innerHTML = text;
            const recommendations = html.querySelector('product-recommendations');
            if (recommendations && recommendations.innerHTML.trim().length) {
              this.innerHTML = recommendations.innerHTML;
            }
          })
          .catch((e) => {
            console.error(e);
          });
      };

      new IntersectionObserver(handleIntersection.bind(this), { rootMargin: '0px 0px 200px 0px' }).observe(this);
    }
  }

  customElements.define('product-modal', ProductModal);
  customElements.define('product-recommendations', ProductRecommendations);



  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
	class ProductRecommendations extends HTMLElement {
		constructor() {
			super();

			const handleIntersection = (entries, observer) => {
				if (!entries[0].isIntersecting) return;
				observer.unobserve(this);

				fetch(this.dataset.url)
					.then((response) => response.text())
					.then((text) => {
						const html = document.createElement('div');
						html.innerHTML = text;
						const recommendations = html.querySelector(
							'product-recommendations'
						);
						if (recommendations && recommendations.innerHTML.trim().length) {
							this.innerHTML = recommendations.innerHTML;
						}
					})
					.catch((e) => {
						console.error(e);
					});
			};

			new IntersectionObserver(handleIntersection.bind(this), {
				rootMargin: '0px 0px 200px 0px',
			}).observe(this);
		}
	}

	customElements.define('product-recommendations', ProductRecommendations);

  } catch(e) { console.error(e); }
})();
})();
